import { render, staticRenderFns } from "./ForbiddenError.vue?vue&type=template&id=48105290&scoped=true&"
import script from "./ForbiddenError.vue?vue&type=script&lang=js&"
export * from "./ForbiddenError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48105290",
  null
  
)

export default component.exports